"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AddFilterButton = exports.NoneFound = void 0;
var React = require("react");
var react_popper_1 = require("react-popper");
var utils_1 = require("../../../_Core/utils");
var Highlighted_1 = require("../../../Highlighted/Highlighted");
var PlusIcon_1 = require("../../../Icons/Assets/PlusIcon");
var DropList_1 = require("../../../Lists/DropList/DropList");
var DropListItem_1 = require("../../../Lists/DropList/DropListItem");
var Localization_1 = require("../../../Localization");
var Modal_1 = require("../../../ReactPortalWrapper/Modal");
var setAnnouncement_1 = require("../../../setAnnouncement/setAnnouncement");
var FilterBar_context_1 = require("../FilterBar.context");
var Component_styles_1 = require("./Component.styles");
var NoneFound = function () { return React.createElement(Component_styles_1.NoneFoundWrapper, null, Localization_1.strings.Search_Label_NoResultsFound); };
exports.NoneFound = NoneFound;
var AddFilterButton = function (_a) {
    var OnFilterTypeClick = _a.OnFilterTypeClick, Disabled = _a.Disabled, ShowSearch = _a.ShowSearch;
    var _b = FilterBar_context_1.useFilterBarContext(), FilterTypes = _b.FilterTypes, DoesItemHaveValue = _b.DoesItemHaveValue;
    var _c = React.useState(false), visible = _c[0], setVisible = _c[1];
    var addButtonRef = React.useRef();
    var _d = React.useState(""), searchString = _d[0], setSearchString = _d[1];
    var sayPolitely = setAnnouncement_1.setAnnouncement().sayPolitely;
    var orderByName = function (dataSource) {
        dataSource.sort(function (a, b) {
            if (a.Name < b.Name) {
                return -1;
            }
            if (a.Name > b.Name) {
                return 1;
            }
            return 0;
        });
        return dataSource;
    };
    var _e = React.useState(orderByName(FilterTypes)), selected = _e[0], setSelected = _e[1];
    var isFilterAlreadyAdded = function (item) {
        return DoesItemHaveValue(item.Name);
    };
    var handleFilterTypeClick = function (item) {
        OnFilterTypeClick(item);
        setVisible(false);
    };
    var handleSearched = function (searched) {
        return new Promise(function (resolve) {
            setSearchString(searched);
            var regex = RegExp(searched, "ig");
            var newData = orderByName(FilterTypes)
                .filter(function (e) { return e; })
                .filter(function (e) { return e.Name.match(regex); });
            setSelected(newData);
            resolve();
            sayPolitely(utils_1.getResultCountMessage(newData.length));
        });
    };
    var handleSearchCancelled = function () {
        return new Promise(function (resolve) {
            setSearchString("");
            setSelected(FilterTypes);
            resolve();
        });
    };
    var handleCloseDropdown = function () {
        setSearchString("");
        setSelected(FilterTypes);
        setVisible(false);
        if (addButtonRef.current) {
            addButtonRef.current.focus();
        }
    };
    React.useEffect(function () {
        if (visible) {
            document.addEventListener("click", handleCloseDropdown);
        }
        return function () {
            document.removeEventListener("click", handleCloseDropdown);
        };
    }, [visible]);
    var handleOnClick = function (e) {
        e.stopPropagation();
        setVisible(!visible);
    };
    return (React.createElement(react_popper_1.Manager, null,
        React.createElement(react_popper_1.Reference, null, function (_a) {
            var ref = _a.ref;
            return (React.createElement("div", { ref: ref },
                React.createElement(Component_styles_1.AddButton, { type: "button", ref: addButtonRef, onClick: handleOnClick, disabled: Disabled },
                    React.createElement(PlusIcon_1.PlusIcon, null),
                    React.createElement("span", null, Localization_1.strings.FilterBar_Label_AddFilter))));
        }),
        React.createElement(Modal_1.Modal, { DisableAutoFocus: true },
            React.createElement(react_popper_1.Popper, { placement: "bottom-start" }, function (_a) {
                var ref = _a.ref, style = _a.style;
                return visible && (React.createElement("div", { ref: ref, style: style },
                    React.createElement(DropList_1.DropList, { OnCloseMenu: handleCloseDropdown, ShowSearch: ShowSearch, OnSearch: handleSearched, OnSearchCancel: handleSearchCancelled }, selected.length > 0 ? (selected.map(function (e) { return (React.createElement(DropListItem_1.DropListItem, { key: e.Name, Disabled: isFilterAlreadyAdded(e), OnClick: function () { return handleFilterTypeClick(e); } },
                        React.createElement(Highlighted_1.Highlighted, { Text: e.Name, Highlight: searchString }))); })) : (React.createElement(exports.NoneFound, null)))));
            }))));
};
exports.AddFilterButton = AddFilterButton;
